module.exports = __webpack_public_path__ + "pcstatic/img/book5.829eb28.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book5.png
// module id = GKVD
// module chunks = 34